import {
  GET_ENTITY_EXECUTIVE_DASHBOARD_SECTION,
  GET_ENTITY_EXECUTIVE_DASHBOARD_SUMMARY,
  GET_ENTITY_EXECUTIVE_PROJECT_ORDER_RFQS,
  GET_ENTITY_USER_HOD_DASHBOARD_PERFORMANCE,
  GET_ENTITY_VENDOR_INSIGHTS_DASHBOARD,
  GET_ENTITY_VENDOR_INSIGHTS_DASHBOARD_SECTION,
  GET_PURCHASE_MANAGER_DASHBOARD,
} from "config/services";
import axios from "utils/axios";

const FULL_DASHBOARD_TIMEOUT_MS = 120000;

class DashboardService {
  fetchEntityExecutiveSummary = ({ entityId, period, from, to, dateRanges, projectIds, summaryOnly }) =>
    new Promise((resolve, reject) => {
      if (!entityId) {
        reject(new Error("entityId is required"));
        return;
      }

      axios
        .post(
          GET_ENTITY_EXECUTIVE_DASHBOARD_SUMMARY,
          { entityId, period, from, to, dateRanges, projectIds, summaryOnly },
          { timeout: FULL_DASHBOARD_TIMEOUT_MS },
        )
        .then((response) => {
          resolve(response?.data?.payload || {});
        })
        .catch((error) => {
          reject(error);
        });
    });

  fetchEntityExecutiveSection = ({ entityId, section, period, from, to, dateRanges, projectIds }) =>
    new Promise((resolve, reject) => {
      if (!entityId || !section) {
        reject(new Error("entityId and section are required"));
        return;
      }

      axios
        .post(
          GET_ENTITY_EXECUTIVE_DASHBOARD_SECTION,
          { entityId, section, period, from, to, dateRanges, projectIds },
          { timeout: FULL_DASHBOARD_TIMEOUT_MS },
        )
        .then((response) => {
          resolve(response?.data?.payload || {});
        })
        .catch((error) => {
          reject(error);
        });
    });

  fetchEntityProjectOrderRfqs = ({ entityId, period, from, to, dateRanges, projectId, projectIds, projectName, supplierId, supplierName, requesterId, managerId, managerMetric, decision, scope, rank, rfqType, division, category, subCategory, divisionBucket, page = 1, limit = 100 }) =>
    new Promise((resolve, reject) => {
      if (!entityId) {
        reject(new Error("entityId is required"));
        return;
      }

      axios
        .post(
          GET_ENTITY_EXECUTIVE_PROJECT_ORDER_RFQS,
          { entityId, period, from, to, dateRanges, projectId, projectIds, projectName, supplierId, supplierName, requesterId, managerId, managerMetric, decision, scope, rank, rfqType, division, category, subCategory, divisionBucket, page, limit },
          { timeout: FULL_DASHBOARD_TIMEOUT_MS },
        )
        .then((response) => {
          resolve(response?.data?.payload || {});
        })
        .catch((error) => {
          reject(error);
        });
    });
  fetchEntityVendorInsights = ({ entityId, period, from, to, dateRanges, projectIds }) =>
    new Promise((resolve, reject) => {
      if (!entityId) {
        reject(new Error("entityId is required"));
        return;
      }

      axios
        .post(
          GET_ENTITY_VENDOR_INSIGHTS_DASHBOARD,
          { entityId, period, from, to, dateRanges, projectIds },
          { timeout: FULL_DASHBOARD_TIMEOUT_MS },
        )
        .then((response) => {
          resolve(response?.data?.payload || {});
        })
        .catch((error) => {
          reject(error);
        });
    });

  fetchEntityVendorInsightsSection = ({ entityId, section, period, from, to, dateRanges, projectIds, rankFilter }) =>
    new Promise((resolve, reject) => {
      if (!entityId || !section) {
        reject(new Error("entityId and section are required"));
        return;
      }

      axios
        .post(
          GET_ENTITY_VENDOR_INSIGHTS_DASHBOARD_SECTION,
          { entityId, section, period, from, to, dateRanges, projectIds, rankFilter },
          { timeout: FULL_DASHBOARD_TIMEOUT_MS },
        )
        .then((response) => {
          resolve(response?.data?.payload || {});
        })
        .catch((error) => {
          reject(error);
        });
    });
  fetchEntityUserHodPerformance = ({ entityId, memberIds, period, from, to, dateRanges, section }) =>
    new Promise((resolve, reject) => {
      if (!entityId) {
        reject(new Error("entityId is required"));
        return;
      }

      axios
        .post(
          GET_ENTITY_USER_HOD_DASHBOARD_PERFORMANCE,
          { entityId, memberIds, period, from, to, dateRanges, section },
          { timeout: FULL_DASHBOARD_TIMEOUT_MS },
        )
        .then((response) => {
          resolve(response?.data?.payload || {});
        })
        .catch((error) => {
          reject(error);
        });
    });


  fetchEntityUserHodPerformanceSection = ({ entityId, memberIds, period, from, to, dateRanges, section }) =>
    new Promise((resolve, reject) => {
      if (!entityId || !section) {
        reject(new Error("entityId and section are required"));
        return;
      }

      axios
        .post(
          `${GET_ENTITY_USER_HOD_DASHBOARD_PERFORMANCE}/section`,
          { entityId, memberIds, period, from, to, dateRanges, section },
          { timeout: FULL_DASHBOARD_TIMEOUT_MS },
        )
        .then((response) => {
          resolve(response?.data?.payload || {});
        })
        .catch((error) => {
          reject(error);
        });
    });
  fetchPurchaseManagerOverview = ({ entityId, userId, scope, period, from, to }) =>
    new Promise((resolve, reject) => {
      if (!entityId || !userId) {
        reject(new Error("entityId and userId are required"));
        return;
      }

      axios
        .post(
          GET_PURCHASE_MANAGER_DASHBOARD,
          { entityId, userId, scope, period, from, to },
          String(scope || "").toLowerCase() === "full"
            ? { timeout: FULL_DASHBOARD_TIMEOUT_MS }
            : undefined,
        )
        .then((response) => {
          resolve(response?.data?.payload || {});
        })
        .catch((error) => {
          reject(error);
        });
    });
}

export const dashboardService = new DashboardService();
